import { Component, Input } from "@angular/core";
import { LoginService } from "@app/login/login.service";
import { MatDialog, MatDialogConfig, MatDialogRef } from "@angular/material/dialog";
import { EditArticleComponent } from "@app/pages/news/edit-article/edit-article.component";
import { AlertsService } from "@app/utilities/alerts.service";
import { NewsModal, NewsService } from "@app/services/news/news.service";

@Component({
  selector: "flex-article",
  templateUrl: "./article.component.html",
  styleUrls: ["./article.component.css"]
})
export class ArticleComponent {
  @Input()
  article: NewsModal;
  hover: boolean = false;
  dialogRef: MatDialogRef<any>;
  dialogConfig = new MatDialogConfig();

  constructor(public loginService: LoginService, public dialog: MatDialog, public newsService: NewsService, public snackBar: AlertsService
  ) {
  }

  //opens the edit dialog
  edit() {
    this.dialogConfig.data = { data: { article: this.article, isNew: false }, ref: this.dialogConfig };
    this.dialogConfig.width = "800px";
    this.dialogConfig.height = "800px";
    this.dialogRef = this.dialog.open(EditArticleComponent, this.dialogConfig);
  }

  //deletes the selected article
  delete() {
    this.newsService.delete(this.article);
  }
}
